import { TableColumn } from "../../../app/components/shared/models/table-models";

export interface TableConfig {
  columns: TableColumn[];
  data: any[];
}

export const TABLE_LIBRARY:
Record<string, TableConfig> = {

  institutionalHighlights: {
    columns: [
      {
        key: 'indicator',
        label: 'Indicator'
      },
      {
        key: 'value',
        label: 'Value'
      }
    ],

    data: [
      {
        indicator: 'Total Assets',
        value: '5,679'
      },
      {
        indicator: 'Loan Portfolio',
        value: '4,490'
      }
    ]
  },
summaryTerms: {
  columns: [
    {
      key: 'description',
      label: 'Description'
    },
    {
      key: 'recommendation',
      label: 'Recommendation'
    }
  ],

  data: []
}
};